import React from 'react';
import Icon from "../../Atoms/Icon";
import NomineCalculate from "../../../static/images/stories/nomine-calculate.svg";
import Calculator from "../../../static/images/utils/calculator.svg";
import Container from "../../Wrappers/Container";

const DashboardWelcome = () => {

  return (
    <Container className="m-cols-2 flex nowrap">
      <div className="s-column flex-grow">
        <h3 className="s-mb-8px">Hola, Evelyn</h3>
        <p className="s-mb-16px small s-mr-8px">Hoy es un excelente día para calcular la nómina</p>
        <a href="#"
          className="s-to-bottom s-cross-center">
          <span className="s-mr-8px">Revisa las nóminas</span>
          <Icon svg="right-arrow"/>
        </a>
      </div>
      <img className="from-m s-mt-48px s-to-right"
        src={NomineCalculate}
        alt="Persona calculando la nómina con nomineros, la mejor plataforma para gestión de nóminas"/>
      <img className="to-m s-to-right s-h-64px"
        src={Calculator}
        alt="Persona calculando la nómina con nomineros, la mejor plataforma para gestión de nóminas"/>
    </Container>
  );
};

export default DashboardWelcome;
